import { render, staticRenderFns } from "./AddTerm.vue?vue&type=template&id=41bc6dcb&scoped=true"
import script from "./AddTerm.vue?vue&type=script&lang=js"
export * from "./AddTerm.vue?vue&type=script&lang=js"
import style0 from "./AddTerm.vue?vue&type=style&index=0&id=41bc6dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bc6dcb",
  null
  
)

export default component.exports